import { render, staticRenderFns } from "./ChbEditPageFooter.vue?vue&type=template&id=286fd40f&scoped=true"
import script from "./ChbEditPageFooter.vue?vue&type=script&lang=js"
export * from "./ChbEditPageFooter.vue?vue&type=script&lang=js"
import style0 from "./ChbEditPageFooter.vue?vue&type=style&index=0&id=286fd40f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286fd40f",
  null
  
)

export default component.exports